import getLanguage from "../get-language.js";

(async () => {
   const otpContainer = document.getElementById("otpScreenContainer");
   if (otpContainer) {
      let requestCodeBtn = otpContainer.querySelector("#requestCodeBtn");
      let submitCodeBtn = otpContainer.querySelector("#submitButton");
      let otpInput = otpContainer.querySelector("#OTP-input");
      let timer_text = otpContainer.querySelector("#timer_text");
      let otp_Counter = otpContainer.querySelector("#otp_Counter");
      let attempt_count_section = otpContainer.querySelector("#attempt_count_section");
      let resend_link_not_available = otpContainer.querySelector("#resend_link_not_available");
      let resend_link = otpContainer.querySelector("#resend_link");
      let otpEl = otpContainer.querySelectorAll(".otp-input");
      let otpErrMsg = otpContainer.querySelectorAll(".otp-err-msgs");
      let verifyWithEmailLink = otpContainer.querySelector("#verifyWithEmail");
      let verifyWithMobileLink = otpContainer.querySelector("#verifyWithMobile");
      let sectionEmail = otpContainer.querySelector("#sectionEmail");
      let sectionMobile = otpContainer.querySelector("#sectionMobile");
      let emailIdDetail = otpContainer.querySelectorAll(".email_id_detail");
      let mobileIdDetail = otpContainer.querySelectorAll(".mobile_id_detail");
      let mobileGetOtpDesc = otpContainer.querySelector("#mobileGetOtpDesc");
      let mobileVerifyOtpDesc = otpContainer.querySelector(
         "#mobileVerifyOtpDesc"
      );
      let emailGetOtpDesc = otpContainer.querySelector("#emailGetOtpDesc");
      let emailVerifyOtpDesc = otpContainer.querySelector(
         "#emailVerifyOtpDesc"
      );
      let OtpErrorField = otpContainer.querySelector(
         "#OtpErrorField"
      );
      let otpVerifyErrorField = otpContainer.querySelector(
         "#otpVerifyErrorField"
      );
      let otpErrorAny = otpContainer.querySelector(
         "#otpErrorAny"
      );
      let otpErrorGeneric = otpContainer.querySelector(
         "#otpErrorGeneric"
      );
      let err_msg_set = otpContainer.querySelectorAll(".otp-err-msgs")  
      const overLayContainer = document.querySelector('#otp_error_modal');
      const closeOverlayButton = document.querySelectorAll('.closeOverlayBtn');
      let otpErrorMsgCustom = document.getElementById('otpErrMsgCustom');
      let deviceType = getUrlParameter("deviceType")?.toUpperCase() || "SMS";
      let customerDetails = JSON.parse(window.sessionStorage.getItem("trans-wa-app"));
      const sessionId = window.sessionStorage.getItem("trans-wa-sessionId");
      const stateToken =  window.sessionStorage.getItem("trans-wa-stateToken");
      const receiverCountry = customerDetails?.customer?.address?.countryCode || 'MX'
      const phoneNo =  customerDetails?.customer?.phoneNumber[0]?.number;
      const maskedPhoneNo = window.sessionStorage.getItem("trans-wa-masked-phoneno") || "";
      const mtcn =  window.sessionStorage.getItem("trans-wa-mtcn") || " "
      let countryCode =  customerDetails?.customer?.phoneNumber[0]?.countryCode;
      let timerId;
      const externalRefId =  window.sessionStorage.getItem("trans-wa-externalRefId") || getUrlParameter('id')|| sessionId;
      const senderCountry ="US" // Need this from Chatbot Team    
      const {
         lang,
         country
      } = getLanguage();

      const languageFromUrl = getLocalLanguage(lang);
      let atExhaustFlag = false;

      const triggerSendStateFactorAPI = async (stateToken , sessionId) => {
         let otpResponse = await window.queryData.triggerSendStateFactor(
            receiverCountry,
            languageFromUrl,
            sessionId,
            externalRefId,
            stateToken,
            deviceType
         );
         
            if (otpResponse?.status === "SUCCESS") {
            
              if (otpResponse?.at_count === 0) {
               toggleClass(attempt_count_section, "d-flex", "d-none");
               toggleClass(resend_link_not_available, "d-none", "d-flex");
              
              }
              else{
               attempt_count_section.innerHTML=  attempt_count_section.innerHTML.replace(
                 `{{attempt_count}}`,
                 otpResponse?.at_count
               );
              }
              resendTimer(otpResponse?.at_count == 0)
            } 
            else {
             
              if(otpResponse?.errorCode === "C7029" || otpResponse?.errorCode === "C9999"){
                  showError(otpResponse.errorCode, otpResponse.message);  
                  toggleClass(resend_link, "d-none", "d-flex");
              }
              else {
                showError(otpResponse.errorCode, otpResponse.message);
                toggleClass(resend_link, "d-flex", "d-none");
                toggleClass(timer_text,"d-block",'d-none')
                toggleClass(attempt_count_section, "d-flex", "d-none");
                submitButton.setAttribute("disabled", true);
              }
            }     
      }

      const handleCustomerLookup = async (token)=>{
       
          const customerResponse = await window.queryData.triggerCustomerLookup(receiverCountry , sessionId, externalRefId ,phoneNo, countryCode)
          if(customerResponse?.errorCode){
            toggleClass(overLayContainer, 'd-block','d-none') 
          }
          else{
            if(customerResponse && customerResponse[0]?.customer?.id){
               let parameter = new URLSearchParams();
               parameter.append("token",token);
               parameter.append("customerID",customerResponse[0]?.customer?.id)
               parameter.append("receiverCountry",receiverCountry)
               parameter.append("senderCountry",senderCountry)
               parameter.append("mtcn",mtcn)
               const queryString = parameter.toString();
               window.location.href =  `/global/`+lang+`/add-bank.html?${queryString}`
            }
          }
      }

      const triggerSigninUserAPI = async ()=>{
         let email = customerDetails?.customer?.email 
         let password = customerDetails?.customer?.credential?.password ;

         let customerProfile = {
            "profile": {
                "email": email,
                "credentials": {
                    "password": password
                }
            }
        }
       
        const customerSigninResponse = await window.queryData.triggerSigninUser(
         receiverCountry,
         languageFromUrl,
         sessionId,
         externalRefId,
         customerProfile
        );
        if (customerSigninResponse?.tokenResponse) {
          let token = customerSigninResponse?.tokenResponse?.access_token;
          handleCustomerLookup(token);
        } else {

          if (customerSigninResponse?.error) {
            if(customerSigninResponse?.error?.errorMessage){
                showError(customerSigninResponse?.error,customerSigninResponse.errorMessage);
            }
            else if(customerSigninResponse?.error?.message){
                showError(customerSigninResponse?.error,customerSigninResponse.message);
            }
          }
        }
      }

      const triggerVerifyStateFactorAPI = async (otp) => {
        if (sessionId && stateToken) {
          const verStateFactRes = await window.queryData.triggerVerifyStateFactor(
            receiverCountry,
            languageFromUrl,
            otp,
            sessionId,
            externalRefId,
            stateToken,
            deviceType
          );

          if (verStateFactRes) {
            clearOtpInput()
            if (verStateFactRes.status === "SUCCESS") { 
              const userRegisteredResponse = await window.queryData.triggerUserRegistration(
                receiverCountry,
                languageFromUrl,
                sessionId,
                externalRefId,
                customerDetails
              );

              if (userRegisteredResponse) {
                if (userRegisteredResponse?.status === "CREATED") {
                  triggerSigninUserAPI();
                }
                else {
                  if (userRegisteredResponse.ok === false && userRegisteredResponse.status === 500) {
                    showError("C9999", "");
                  } else if (userRegisteredResponse?.errorCode) {
                    showError(userRegisteredResponse.errorCode, userRegisteredResponse?.message);
                  } else if (userRegisteredResponse.error.errorCode) {
                    showError(userRegisteredResponse.error.errorCode ,userRegisteredResponse.error.errorMessage);
                  }else if(userRegisteredResponse.status === 400 || userRegisteredResponse.status === 401 ){
                    showError("C9999", "");
                  }             
                }
              }
            }

            else if (verStateFactRes?.status === "FAILURE" )
            {
              
               if(verStateFactRes?.at_count > 0){
                  toggleClass(resend_link, "d-none", "d-flex");
                  toggleClass(otpVerifyErrorField, "d-none", "d-flex");
                  toggleClass(attempt_count_section, "d-flex", "d-none");
                  toggleClass(timer_text, "d-block", "d-none");
               }
               else
               {
                  clearAllMessages();
                  overLayContainer?.classList?.add("d-block");
                  overLayContainer?.classList?.remove("d-none");
                  submitButton.setAttribute("disabled", true);
               }

            }
            else {
               clearAllMessages();

               if (verStateFactRes?.error || verStateFactRes.errorCode) {
                  const customMsg = verStateFactRes.message ? verStateFactRes?.message :verStateFactRes?.errorMessage
                  otpErrorMsgCustom.innerHTML = customMsg;
                  toggleClass(otpErrorMsgCustom, "d-none", "d-flex");
                  toggleClass(otpErrMsgDefault, "d-flex", "d-none");
               } else {
                  toggleClass(otpErrorMsgCustom, "d-flex", "d-none");
                  toggleClass(otpErrMsgDefault, "d-none", "d-flex");
               }
               if (verStateFactRes?.error || verStateFactRes.errorCode) {
                  overLayContainer?.classList?.add("d-block");
                  overLayContainer?.classList?.remove("d-none");
                  submitButton.setAttribute("disabled", true);
               }
              
            }
            
          }
        }
      };

      const getOtpOnDevice = () => {
        if (sessionId && stateToken)
          triggerSendStateFactorAPI(stateToken, sessionId);
      };
            
      const initOtpPage = () => {
         let otp_email_value = customerDetails?.customer?.email;
         if (otp_email_value) {
            emailIdDetail.forEach((n) => {
               n.innerHTML = customerDetails.customer.email;
            });
         }

         if (phoneNo && maskedPhoneNo) {
            mobileIdDetail.forEach((n) => {
               n.innerHTML = maskedPhoneNo;
            });
         }

         if (window.location.href.indexOf("send-otp") !== -1) {
            requestCodeBtn.removeAttribute("disabled");

            if (deviceType === "SMS") {
               toggleClass(mobileGetOtpDesc, "d-none", "d-block");
               toggleClass(emailGetOtpDesc, "d-block", "d-none");
            } else {
               toggleClass(mobileGetOtpDesc, "d-block", "d-none");
               toggleClass(emailGetOtpDesc, "d-none", "d-block");
            }

         }  
         else {
          
            toggleClass(requestCodeBtn, "d-block", "d-none");
            toggleClass(submitCodeBtn, "d-none", "d-block");
            toggleClass(otpInput, "d-none", "d-block");


            //On Device type Change Email Section or Mobile Section
            if (deviceType === "SMS") {
              toggleClass(sectionEmail, "d-block", "d-none");
              toggleClass(sectionMobile, "d-none", "d-block");
              toggleClass(verifyWithEmailLink, "d-none", "d-flex");
              toggleClass(verifyWithMobileLink, "d-flex", "d-none");
            } else {
              toggleClass(sectionEmail, "d-none", "d-block");
              toggleClass(sectionMobile, "d-block", "d-none");
              toggleClass(verifyWithEmailLink, "d-flex", "d-none");
              toggleClass(verifyWithMobileLink, "d-none", "d-flex");
            }
            getOtpOnDevice();
         }
      };

      initOtpPage();
    
      for (let i = 0; i < otpEl.length; i++) {
         otpEl[i].addEventListener('input', (e) => {
            e.target.setAttribute('value', e.target.value);
            let value = e.target.value
            if (value) value = parseInt(value)
            if (value && value > 9) {
               e.target.value = value % 10
            }
            if (i < otpEl.length - 1) {
               otpEl[i + 1].focus()
            }

         })

         otpEl[i].addEventListener('keydown', (e) => {

            if (e.key === "Backspace" || e.code === "Backspace") {
               if (!e.target.value && i > 0) {
                  otpEl[i - 1].value = ''
                  otpEl[i - 1].focus()
               }
            }
         })
      }

      const clearAllMessages = ()=>{
         err_msg_set.forEach((n) => {
           n.classList.remove("d-flex");
           n.classList.remove("d-block");
           n.classList.add("d-none");
         });
      }

      const changeDevicetoEmail= ()=>{
         deviceType = "EMAIL";
        
         if(window.location.href.indexOf("send-otp") !== -1){
            toggleClass(emailGetOtpDesc, "d-none", "d-flex");
            toggleClass(emailVerifyOtpDesc, "d-flex", "d-none");
         }
         else if(window.location.href.indexOf("verify-otp") !== -1){
            toggleClass(emailVerifyOtpDesc, "d-none", "d-flex");
            toggleClass(emailGetOtpDesc, "d-flex", "d-none");
         }
         toggleClass(sectionEmail, "d-none", "d-block");
         toggleClass(sectionMobile, "d-block", "d-none");
         toggleClass(verifyWithEmailLink, "d-flex", "d-none");
         toggleClass(verifyWithMobileLink, "d-none", "d-flex");

      }

      const changeDevicetoMobile= ()=>{
         deviceType = "SMS";
         if(window.location.href.indexOf("send-otp") !== -1){
            toggleClass(mobileGetOtpDesc, "d-none", "d-flex");
            toggleClass(mobileVerifyOtpDesc, "d-flex", "d-none");
         }
         else if(window.location.href.indexOf("verify-otp") !== -1){
            toggleClass(mobileVerifyOtpDesc, "d-none", "d-flex");
            toggleClass(mobileGetOtpDesc, "d-flex", "d-none");
         }
         toggleClass(sectionMobile, "d-none", "d-block");
         toggleClass(sectionEmail, "d-block", "d-none");
         toggleClass(verifyWithEmailLink, "d-none", "d-flex");
         toggleClass(verifyWithMobileLink, "d-flex", "d-none")
      }

      const redirectToRegistration = ()=>{
          let parameter = new URLSearchParams();
          parameter.append("receiverCountry",receiverCountry)
          parameter.append("senderCountry",senderCountry)
          parameter.append("givenName",customerDetails.customer.name.givenName)
          parameter.append("surname1",customerDetails.customer.name.paternal)
          parameter.append("surname2",customerDetails.customer.name.maternal)
          parameter.append("mtcn",customerDetails.mtcn)
          parameter.append("countryCode",countryCode)
          parameter.append("phone",phoneNo)
          const queryFullRegister = parameter.toString();
          window.location.href = `/global/` + lang + `/full-registration.html?${queryFullRegister}`;
      
      }
      
      closeOverlayButton.forEach((x) => {
         x.addEventListener("click", ()=>{
            clearOtpInput();
            redirectToRegistration();
            toggleClass(overLayContainer ,'d-block','d-none')
         });
       });

    
      verifyWithEmailLink.addEventListener("click", changeDevicetoEmail);
      verifyWithMobileLink.addEventListener("click", changeDevicetoMobile);
   
      let resendTimer = (atExhaustFlag) => {
         let timeLeft = 30;
          timerId = setInterval(() => {
            if (timeLeft == -1) {
               clearTimeout(timerId);
               toggleClass(resend_link, "d-none", "d-flex");
               toggleClass(timer_text, "d-block", "d-none");
               toggleClass(attempt_count_section, "d-none", "d-flex");
               
            } else {
               toggleClass(attempt_count_section, "d-flex", "d-none");
               toggleClass(resend_link, "d-flex", "d-none");
               toggleClass(timer_text, "d-none", "d-block"); 
               otp_Counter.innerHTML =  timeLeft + " seconds remaining";
               timeLeft--;
            }
            if (atExhaustFlag) {
              clearAllMessages();
              toggleClass(resend_link_not_available, "d-none", "d-flex");
              toggleClass(timer_text, "d-none", "d-block"); 
               otp_Counter.innerHTML =  timeLeft + " seconds remaining";
               timeLeft--;
            }

         }, 1000);
      };

      
      const showError = (errorCode , errorMsg)=>{
         if(errorCode === "C9999"){
             toggleClass(otpErrorAny, "d-block", "d-none");
             toggleClass(otpErrorGeneric, "d-block", "d-none");
         }
         else{
             otpErrorAny.innerHTML = errorMsg 
             toggleClass(otpErrorAny, "d-none", "d-block");
             toggleClass(otpErrorGeneric, "d-block", "d-none");
         }
      }

      const clearOtpInput = ()=>{
         for (let i = 0; i < otpEl.length; i++) {  otpEl[i].value = "" ; otpEl[i].setAttribute('value',0)}
      }

      resend_link.addEventListener("click", () => {
        clearOtpInput();
        clearAllMessages();
        attempt_count_section.innerHTML = attempt_count_section.getAttribute("data-value");
        getOtpOnDevice();
      });
      
      requestCodeBtn.addEventListener("click", () => {
         window.location.href = `/global/` + lang + `/verify-otp.html?deviceType=`+deviceType;
      });

      submitCodeBtn.addEventListener("click", () => {
         clearTimeout(timerId);
         clearAllMessages();

         let otp = ``;
         for (let i = 0; i < otpEl.length; i++) {
            otp += otpEl[i].value;
         }
         submitButton.setAttribute("disabled", true);
         triggerVerifyStateFactorAPI(otp) 
      });

      otpEl.forEach(input => {
      input.addEventListener('input', () => {
         const allFilled = Array.from(otpEl).every(input => input.value.length === 1);
         submitCodeBtn.disabled = !allFilled;
      });
      });
   }
})();